import React, { useState } from "react";
import ProductList from "./ProductList";
// import styles from "./ProductsTable.module.css";
import { Product } from "../../Store/interfaces";
import { useScheinContext } from "../../Store/schein-context";
import { useUIContext } from "../../Store/ui-context";
// import { isExportAssignment } from "typescript";

interface ProductGroupProps {
  groupName: string;
  groupProducts: Product[];
  onProductSelect: (productId: number) => void;
}

const ProductGroup: React.FC<ProductGroupProps> = ({
  groupName,
  onProductSelect,
  groupProducts,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const { selectedProducts } = useScheinContext();
  const { currentProductID, setCurrentProductID } = useUIContext();
  const totalQuantity = groupProducts.reduce((sum, product) => {
    const isSelected = selectedProducts.some(
      (selectedProduct) => selectedProduct.id === product.id
    );
    return isSelected ? sum + 1 : sum;
  }, 0);

  const productIsSelected = groupProducts.some(
    (product) => product.id === currentProductID
  );

  if (productIsSelected && !isExpanded) {
    setIsExpanded(true);
  }

  // return (
  //   <div className="mr-4 ml-4">
  //     <div
  //       className="mt-1 flex mx-auto items-center
  //        justify-between border border-gray-300
  //         rounded-lg bg-blue_royal w-9/10 text-white
  //          p-2.5 transition-transform hover:scale-105"
  //       onClick={() => {
  //         setIsExpanded(!isExpanded);
  //         setCurrentProductID(0);
  //       }}
  //     >
  //       <p>
  //         {groupName} ({groupProducts.length})
  //       </p>
  //       <p>{totalQuantity > 0 && `(${totalQuantity}x ausgewählt)`}</p>
  //     </div>

  //     {isExpanded && (
  //       <ProductList
  //         groupProducts={groupProducts}
  //         onProductSelect={onProductSelect}
  //       />
  //     )}
  //   </div>
  // );

  return (
    <div className="mx-2 sm:mx-4">
      <div
        className="mt-1 flex mx-auto items-center justify-between
          border border-gray-300 rounded-lg bg-blue_royal
          w-full sm:w-10/12 text-white
          p-2 sm:p-3 transition-transform hover:scale-105 cursor-pointer"
        onClick={() => {
          setIsExpanded(!isExpanded);
          setCurrentProductID(0);
        }}
      >
        <p className="text-sm sm:text-base md:text-lg">
          {groupName} ({groupProducts.length})
        </p>
        <p className="text-sm sm:text-base md:text-lg">
          {totalQuantity > 0 && `(${totalQuantity}x ausgewählt)`}
        </p>
      </div>

      {isExpanded && (
        <div className="w-full sm:w-10/12 mx-auto">
          <ProductList
            groupProducts={groupProducts}
            onProductSelect={onProductSelect}
          />
        </div>
      )}
    </div>
  );
};

export default ProductGroup;
